export { default as generateStaticImageSrcSet } from './generateStaticImageSrcSet';
